export const PROJECT_PAGE_CONFIG = {
    name            : 'Page',
    icon            : 'ii5-task-list', //'i5-sticky-note',
    // iconLight       : 'ii5-task-list', //'i5-document-light',
    image           : 'notes-docs',
    iconSvg         : 'isvg-pages',
    url             : 'page',
    stringId        : 'page',
    description     : 'Page view description',
    menuName        : 'Page',
    inheritance     : false,
}
